import React from 'react';
import './styles/bannerFamily.css';

const families = [
    {
      image: "./../family_old.png",
      bgColor: "#E3F1FF",
    },
    {
      image: "./../family_middle.png",
      bgColor: "#D4FBE3",
    },
    {
      image: "./../family_bottom.png",
      bgColor: "#C1F1FF",
    },
  ];

const FamilyCard = ({ image, bgColor }: { image: string; bgColor: string }) => {
    return (
      <div className="family-card">
        <img src={image} alt="Family" className="family-image" />
        <div className="shadow-back" style={{ backgroundColor: bgColor }}></div>
        <div className="shadow-frame"></div>
      </div>
    );
  };

const BannerFamily = () => {
    return (
        <div className="gallery-wrapper">
            <div className="gallery">
                <div className="card-top">
                    <FamilyCard image={families[0].image} bgColor={families[0].bgColor} />
                </div>
                <div className="card-middle">
                    <FamilyCard image={families[1].image} bgColor={families[1].bgColor} />
                </div>
                <div className="card-bottom">
                    <FamilyCard image={families[2].image} bgColor={families[2].bgColor} />
                </div>
            </div>
        </div>
    )
}

export default BannerFamily;